import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

import Login from "./views/login/Login";
import DynPage from "./views/dynpage/DynPage";
import InterviewPage from "./views/interview/InterviewPage";
import UserListPage from "./views/userlist/UserListPage";
import ReportsPage from "./views/reports/ReportsPage";
import SettingsPage from "./views/settings/SettingsPage";
import NewPasswordPage from "./views/login/NewPasswordPage";
import KeyIngressPage from "@/views/keyingress/KeyIngressPage";

Vue.use(Router)

let router = new Router({
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login,
            meta: {requiresAuth: false, hideHeader: true, hideNavSidebar: true}
        },

        {
            path: '/newpwd/:resetToken',
            name: 'newpwd',
            component: NewPasswordPage,
            meta: {requiresAuth: false, hideHeader: true, hideNavSidebar: true}
        },

        {
            path: '/invite/:inviteToken',
            name: 'invite',
            component: NewPasswordPage,
            meta: {requiresAuth: false, hideHeader: true, hideNavSidebar: true}
        },


        {
            path: '/seite/:pageName/:study/:view',
            name: 'seite',
            component: DynPage,
            meta: {requiresAuth: true}
        },

        {
            path: '/seite/:pageName/:study/:view/:path',
            name: 'seite',
            component: DynPage,
            meta: {requiresAuth: true}
        },

        {
            path: '/interview/:study/:path',
            name: 'interview',
            component: InterviewPage,
            meta: {requiresAuth: true, hideNavSidebar: false, disableHeaderControls: true }
        },

        {
            path: '/users/:study',
            name: 'users',
            component: UserListPage,
            meta: {requiresAuth: true}
        },

        {
            path: '/reports/:study',
            name: 'reports',
            component: ReportsPage,
            meta: {requiresAuth: true}
        },

        {
            path: '/settings/:study',
            name: 'settings',
            component: SettingsPage,
            meta: {requiresAuth: true}
        },

        {
            path: '/keyingress/:study',
            name: 'keyingress',
            component: KeyIngressPage,
            meta: {requiresAuth: true}
        }


    ]
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!store.getters.isLoggedIn) {
            // console.log("Not logged in - forwarding to login page")

            next({path: '/', query: {redirect: to.fullPath}})
        } else {
            // console.log("All good from router - we are logged in")
            next()
        }
    } else {
        next() // make sure to always call next()!
    }
})

export default router
